export default __webpack_public_path__ + "static/media/item3.eec91da6.png";